export default {
  buttons: {
    add: 'Añadir',
  },
  AddOn: {
    label: 'Complemento',
    title: 'Obtén tu app móvil',
    subscribed: 'Suscrito',
    cta: 'Obtén tu app móvil',
    price_per_month: '{{price}} / mes',
    tax_included: 'impuestos incluidos',
    apple_developer_note:
      'Requiere una cuenta de Apple Developer (99 $/año, pagados a Apple) a nombre de la entidad legal del restaurante.',
    features: {
      stores: 'Disponible en App Store y Google Play',
      push: 'Notificaciones push a tus clientes',
      loyalty: 'Puntos de fidelidad y recompensas',
      commission: 'Pedidos directos con 0% de comisión',
    },
  },
};
